const META_PIXEL_ID = '1131041179059962'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('img')
  noscript.height = 1
  noscript.width = 1
  noscript.style.display = 'none'
  noscript.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscript)

  f.fbq('init', META_PIXEL_ID)
  f.fbq('track', 'PageView')
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', eventName, params)
  }
}
